import {
    LIST_AUDIENCE_TYPES,
    LIST_AUDIENCE_TYPES_SUCCESS,
    LIST_AUDIENCE_TYPES_ERROR,
    ADD_AUDIENCE_TYPES,
    SAVE_AUDIENCE_TYPES,
    SAVE_AUDIENCE_TYPES_SUCCESS,
    SAVE_AUDIENCE_TYPES_ERROR,
    DELETE_AUDIENCE_TYPES,
    DELETE_AUDIENCE_TYPES_SUCCESS,
    DELETE_AUDIENCE_TYPES_ERROR,
    EDIT_AUDIENCE_TYPES,
    UPDATE_AUDIENCE_TYPES,
    UPDATE_AUDIENCE_TYPES_SUCCESS,
    UPDATE_AUDIENCE_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import audienceTypesData from '../data/audienceTypes';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'audiencia-tipo';

//LISTAR AUDIENCE TYPES
export function listAudienceTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listAudienceTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const audienceTypes = response.data;
            //const audienceTypes = audienceTypesData;
            //Llamo al dispatch
            dispatch( listAudienceTypesSuccess(audienceTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listAudienceTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listAudienceTypes = () => ({
    type: LIST_AUDIENCE_TYPES,
    payload: true
});

const listAudienceTypesSuccess = audienceTypes => ({
    type: LIST_AUDIENCE_TYPES_SUCCESS,
    payload: audienceTypes
});

const listAudienceTypesError = error => ({
    type: LIST_AUDIENCE_TYPES_ERROR,
    payload: error
});

//ADD AUDIENCE TYPE
export function addAudienceTypesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addAudienceTypes(false) );
        //Abro el formulario
        showForm();
    }
}

const addAudienceTypes = isEdit => ({
    type: ADD_AUDIENCE_TYPES,
    payload: isEdit
});

//SAVE AUDIENCE TYPE
export function saveAudienceTypesAction(audienceType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveAudienceTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, audienceType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( saveAudienceTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveAudienceTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const saveAudienceTypes = () => ({
    type: SAVE_AUDIENCE_TYPES,
    payload: true
});


const saveAudienceTypesSuccess = audienceType => ({
    type: SAVE_AUDIENCE_TYPES_SUCCESS,
    payload: audienceType
});

const saveAudienceTypesError = error => ({
    type: SAVE_AUDIENCE_TYPES_ERROR,
    payload: error
});

//EDIT AUDIENCE TYPE
export function editAudienceTypesAction(audienceType, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editAudienceTypes(audienceType) );
        //Abro el formulario
        showForm();
    }
}

const editAudienceTypes = audienceType => ({
    type: EDIT_AUDIENCE_TYPES,
    payload: audienceType
});

//UPDATE AUDIENCE TYPE
export function updateAudienceTypesAction(audienceType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateAudienceTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${audienceType.id}`, audienceType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updateAudienceTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateAudienceTypesError(data) );
        }
    }
}

const updateAudienceTypes = () => ({
    type: UPDATE_AUDIENCE_TYPES,
    payload: true
});

const updateAudienceTypesSuccess = audienceType => ({
    type: UPDATE_AUDIENCE_TYPES_SUCCESS,
    payload: audienceType
});

const updateAudienceTypesError = error => ({
    type: UPDATE_AUDIENCE_TYPES_ERROR,
    payload: error
});

//DELETE AUDIENCE TYPE
export function deleteAudienceTypesAction(audienceType) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteAudienceTypes() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${audienceType.id}`);
            const response = await clienteAxios.put(`/${controller}/${audienceType.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deleteAudienceTypesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteAudienceTypesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deleteAudienceTypes = () => ({
    type: DELETE_AUDIENCE_TYPES,
    payload: true
});

const deleteAudienceTypesSuccess = audienceType => ({
    type: DELETE_AUDIENCE_TYPES_SUCCESS,
    payload: audienceType
});

const deleteAudienceTypesError = error => ({
    type: DELETE_AUDIENCE_TYPES_ERROR,
    payload: error
});